import { useCallback, useEffect, useRef } from 'react';
import { useIdleCarouselAutoAdvance } from './useIdleCarouselAutoAdvance';
import { useDashboardContext } from '../DashboardContext';

export function useAutoRotateHoveredModule(idleTimeMs, advanceIntervalMs) {
    const { modules, hoveredModule, setHoveredModule, isDashboardAnimationsEnabled } = useDashboardContext();

    const hoveredModuleRef = useRef(hoveredModule);
    const pauseTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const isPausedRef = useRef(false);

    useEffect(() => {
        hoveredModuleRef.current = hoveredModule;
    }, [hoveredModule]);

    const modulesArray = useRef(Object.entries(modules).map(([key, m]) => ({ ...m, key }))).current;

    const goToNextItem = useCallback(() => {
        if (isPausedRef.current || !isDashboardAnimationsEnabled) return;

        const currentIndex = modulesArray.findIndex((item) => item.key === hoveredModuleRef.current);
        const nextIndex = (currentIndex + 1) % modulesArray.length;
        setHoveredModule(modulesArray[nextIndex].key);
    }, [modulesArray, setHoveredModule, isDashboardAnimationsEnabled]);

    const pause = useCallback(() => {
        isPausedRef.current = true;
        if (pauseTimeoutRef.current) clearTimeout(pauseTimeoutRef.current);
        pauseTimeoutRef.current = setTimeout(() => {
            isPausedRef.current = false;
        }, idleTimeMs);
    }, [idleTimeMs]);

    useIdleCarouselAutoAdvance(goToNextItem, idleTimeMs, advanceIntervalMs);

    return { pause };
}
